import React, { useState } from "react";
import LoginHeader from "../components/Login/LoginHeader";
import ContinueButton from "./ContinueButton";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateUserNames } from "../store/authSlice";

const UserNameForm = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userId = location.state?.userId || "";

  const { isAuthenticated } = useSelector((state) => state.auth);
  const token = useSelector((state) => state.auth.token);


  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstNameError("");
    setLastNameError("");

    if (!firstName) {
      setFirstNameError("First Name is required");
    }
    if (!lastName) {
      setLastNameError("Last Name is required");
    }

    if (firstName && lastName) {
      try {
        const result = await dispatch(
          updateUserNames({ userId, firstName, lastName, authToken: token })
        ).unwrap();

        if (result.success) {
          navigate("/account-type", { state: { userId: result.id }});
        } else {
          setFirstNameError("Failed to update first name.");
          setLastNameError("Failed to update last name.");
        }
      } catch (error) {
        console.error("Error during name update:", error);
        setFirstNameError(error.message || "Failed to update first name.");
        setLastNameError(error.message || "Failed to update last name.");
      }
    }
  };

  return (
    <>
      <LoginHeader isAuthenticated={isAuthenticated}  />
      <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 overflow-scroll px-6 mt-4 sm:mt-24">
      <header className="text-center mb-14">
          <h1 className="text-2xl font-semibold text-[#1d2639]">
            What’s Your Name?
          </h1>
          <p className="text-base font-medium text-[#7e7e7e]">
            Enter your name so we can personalize your experience.
          </p>
        </header>
        <form
          className="flex flex-col justify-center w-full sm:w-[572px]"
          onSubmit={handleSubmit}
          aria-labelledby="form-title"
        >
          <h1 id="form-title" className="sr-only">
            User Name Form
          </h1>

          <fieldset
            className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-10"
            aria-labelledby="first-name-label"
            aria-describedby="first-name-error"
          >
            <legend className="sr-only">User Names</legend>

            <label
              htmlFor="first-name"
              id="first-name-label"
              className="text-[#1d2639] text-base font-normal font-['Lato']"
            >
              First Name
            </label>

            <input
              type="text"
              id="first-name"
              name="first-name"
              placeholder="Enter your First Name"
              className={`w-full h-12 p-3 bg-[#f9f9f9] rounded-lg border-2 ${
                firstNameError ? "border-solid border-1 border-red-500" : ""
              }`}
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
                if (firstNameError) setFirstNameError("");
              }}
              aria-describedby="first-name-error"
            />
            {firstNameError && (
              <span
                id="first-name-error"
                className="text-red-500 text-sm"
                role="alert"
              >
                {firstNameError}
              </span>
            )}
          </fieldset>

          <fieldset
            className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-10"
            aria-labelledby="last-name-label"
            aria-describedby="last-name-error"
          >
            <legend className="sr-only">User Last Name</legend>

            <label
              htmlFor="last-name"
              id="last-name-label"
              className="text-[#1d2639] text-base font-normal font-['Lato']"
            >
              Last Name
            </label>

            <input
              type="text"
              id="last-name"
              name="last-name"
              placeholder="Enter your Last Name"
              className={`w-full h-12 p-3 bg-[#f9f9f9] rounded-lg border-2 ${
                lastNameError ? "border-solid border-1 border-red-500" : ""
              }`}
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                if (lastNameError) setLastNameError("");
              }}
              aria-describedby="last-name-error"
            />
            {lastNameError && (
              <span
                id="last-name-error"
                className="text-red-500 text-sm"
                role="alert"
              >
                {lastNameError}
              </span>
            )}
          </fieldset>

          <ContinueButton
            isDisabled={firstNameError || lastNameError}
            onClick={handleSubmit}
          />
        </form>
      </section>
    </>
  );
};

export default UserNameForm;
